import { CalendarDays } from "lucide-react";

const EventsTileDesign = {
  id: "events",
  icon: CalendarDays,
  label: "Events",
  background: "#5F7D4D",
  color: "#ffffff",
};

export default EventsTileDesign;
